$(function () {
  const $promoBanner = $('.ecommerce .js-promo-banner');

  if($promoBanner.length) {
    // Add animate class to promo banner to show it on page load
    $promoBanner.addClass('animate');
  }
})
